import { useTranslations } from 'next-intl';

import Icon from '@commons/components/Icon';
import Link from '@commons/components/Link';
import Text from '@commons/components/Text';
import Flex from '@commons/containers/Flex';

import styles from './Mobile.module.scss';

/**
 * GardaWorld Footer LogoMenuMobile component.
 */

const LogoMenuMobile = () => {
  const t = useTranslations('footer');

  return (
    <>
      <Link href={t('aboutUs.url')} className={styles.link}>
        <Flex border="bottom" paddingBottom="sm" justify="space-between">
          <Text level="h4" marginBottom="none" weight="normal">
            {t('aboutUs.label')}
          </Text>
          <Icon type="chevronRight" />
        </Flex>
      </Link>
      <Link href={t('mediaInquiries.url')} className={styles.link}>
        <Flex border="bottom" paddingBottom="sm" justify="space-between">
          <Text level="h4" marginBottom="none" weight="normal">
            {t('mediaInquiries.label')}
          </Text>
          <Icon type="chevronRight" />
        </Flex>
      </Link>
    </>
  );
};

export default LogoMenuMobile;
